import { sendJsonRequest, retrieveJsonRequest } from "./utils";

function voterIDFactory(voterID) {
    return voterID ? `?voter_id=${voterID}` : "";
}

function getVoteURL(siteID, postID, voterID) {
    voterID = voterIDFactory(voterID);
    return `/core/v1.1/sites/${siteID}/posts/${postID}/poll/votes${voterID}`;
}

function getResultsURL(siteID, postID, voterID) {
    voterID = voterIDFactory(voterID);
    return `/core/v1.1/sites/${siteID}/posts/${postID}/poll${voterID}`;
}

function getPostRatingUrl(postID) {
    return `/core/v1/polls/post:${postID}:comments:reviews`;
}

export function removeVote(siteID, postID, voterID) {
    return retrieveJsonRequest(getVoteURL(siteID, postID, voterID), "DELETE");
}

export function getResults(siteID, postID, voterID) {
    return retrieveJsonRequest(getResultsURL(siteID, postID, voterID));
}

export function vote(siteID, postID, voterID, body) {
    return sendJsonRequest(getVoteURL(siteID, postID, voterID), "POST", body);
}

export function getPostRating(postId) {
    return retrieveJsonRequest(getPostRatingUrl(postId));
}
